/**
 * Bark 推送配置服务
 *
 * 不再依赖浏览器 Service Worker / PushManager，仅向后端读写 Bark Device Key。
 */

import { userApi } from './api';

export async function getBarkConfig(): Promise<{ barkKeyMask: string; barkServerUrl: string }> {
  const res = await userApi.getBarkConfig();
  return res.data.data;
}

export async function saveBarkConfig(data: { barkKey?: string; barkServerUrl?: string }) {
  return userApi.updateBarkConfig(data);
}

export async function testBarkConfig(): Promise<{ success: boolean; message: string }> {
  const res = await userApi.testBarkConfig();
  return res.data;
}
